import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import {
    qApplicationDetail,
    qBeneDetail,
    qApplicationDetail2,
    qApplicationBeneList,
    qApplicationHouList,
    qAttachment,
    qBeneReceiptList,
} from '../actions/query';
import { encryptQuery } from '../../../utils/common';
import { fetchQueryData } from '../../../utils/sf-request';


export default null;

export function getBeneDetail(key, siteToken, publicKey) {
    const query = `${qBeneDetail}'${key}'`;
    return fetchQueryData(query, siteToken, publicKey);
}


export function getApplicationBeneList(key, siteToken, publicKey) {
    const query = `Select  Contact_Name__r.Name, Race__c,
    Application__r.Applicant_Name__c
    FROM Person__c WHERE Contact_Name__c <> null and Application__r.Related_Account__c = '${key}'  and RecordType.Name = 'Beneficiary'`;

    return fetchQueryData(query, siteToken, publicKey);
}

export function getApplicationHouList(key, siteToken, publicKey) {
    const query = `${qApplicationHouList}'${key}'`;
    return fetchQueryData(query, siteToken, publicKey);
}

export function getApplicationDetail(key, siteToken, publicKey) {
    const query = qApplicationDetail(key);
    return fetchQueryData(query, siteToken, publicKey);
}

export function getAttachment(key, siteToken, publicKey) {
    const query = `${qAttachment}'${key}'`;
    return fetchQueryData(query, siteToken, publicKey);
}
export function getAttachmentStream(key, siteToken) {
    return fetch(`${spmfcloudFunctionUrl}/attachment`, {
        mode: 'cors',
        body: JSON.stringify({
            attachmentId: key,
            siteToken,
        }),
        cache: 'no-cache',
        method: 'POST',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    });
}

export function getBeneReceiptList(key, siteToken) {
    const query = `${qBeneReceiptList}'${key}'`;
    return fetchQueryData(query, siteToken, publicKey);
}

export function submitVerifyBene(data, siteToken) {
    return fetch(`${spmfcloudFunctionUrl}/update-bene-status`, {
        mode: 'cors',
        body: JSON.stringify({
            data,
            siteToken,
        }),
        cache: 'no-cache',
        method: 'POST',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    });
}




//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/services/index.js
// module id = 984
// module chunks = 0